import * as React from 'react';

import { ICustomer } from '../../../../data/entities/customer';
import { IFinancial } from '../../../../data/entities/customer/financial';
import { ISessionState } from '../../../../entities/auth/session/reducers';
import { Accordion, AccordionHeader, AccordionItem } from '../../../components/accordion';
import { Form, FormInput, FormLabel, FormLabelHelp, FormRow } from '../../../components/form';
import { FormInputPhone } from '../../../components/form/form-phone-input/FormInputPhone';
import { Heading } from '../../../components/heading/Heading';
import { Loader } from '../../../components/loader/Loader';
import { withValidation } from '../../../components/validation/ValidationWrap';
import { IValidationResult } from '../validation';

interface IPersonalDetailsProps {
	customer: ICustomer;
	financial: IFinancial;
	authUser: ISessionState;
	validation: IValidationResult[];
	isImpersonating: boolean;
	onChange: (key: keyof ICustomer, value: any) => any;
	onChangeFinancial: (key: keyof IFinancial, value: any) => any;
	onChangeAttribute: (key: string, value: string) => any;
}

interface IPersonalDetailsState {
	next: ICustomer;
}

const FormInputWithValidation = withValidation(FormInput);
const FormInputPhoneWithValidation = withValidation(FormInputPhone);

export class PersonalDetailsEdit extends React.Component<IPersonalDetailsProps, IPersonalDetailsState> {
	constructor(props: IPersonalDetailsProps) {
		super(props);
		this.state = {} as IPersonalDetailsState;
	}

	public render() {
		const {
			customer,
			financial,
			onChange,
			authUser,
			validation,
			onChangeFinancial,
			onChangeAttribute,
			isImpersonating
		} = this.props;

		return !customer ? <Loader loading={true} /> : (
			<div className="customer-details">
				<Accordion>
					<AccordionHeader>Personal details</AccordionHeader>
					<AccordionItem>
						<Heading type="B1">Name</Heading>
						<Form>
							<FormRow>
								<FormLabel htmlFor="name">Full name</FormLabel>
								<FormInputWithValidation
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('name', e.target.value)}
									type="text"
									required
									name="name"
									id="name"
									defaultValue={customer.name}
									validation={validation} />
							</FormRow>

							<Heading type={'B1'}>Contact number</Heading>
							<FormRow>
								<FormLabel htmlFor="phone">Phone number</FormLabel>
								<FormInputPhoneWithValidation
									onChange={(e: any) => onChange('phone', e.target.value)}
									required
									name="phone"
									id="phone"
									validation={validation}
									value={customer.phone || ''} />
							</FormRow>

							<Heading type="B1">Email and login</Heading>
							{isImpersonating && <Heading type="D1">Admins cannot change these details for the user directly</Heading>}
							<FormRow>
								<FormLabel htmlFor="login_email">Login email address</FormLabel>
								<FormLabelHelp>You'll use this to log into your Travelnest account</FormLabelHelp>
								<FormInput
									type="text"
									name="login_email"
									id="login_email"
									defaultValue={authUser.attributes.email}
									disabled={isImpersonating}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeAttribute('email', e.target.value.toLowerCase())}
								/>
							</FormRow>

							<FormRow>
								<FormLabel htmlFor="passwordless">Login method</FormLabel>
								<label htmlFor="passwordless_no">Password</label> &nbsp;
								<FormInput
									type="radio"
									name="passwordless"
									id="passwordless_no"
									disabled={isImpersonating}
									defaultChecked={authUser.attributes['custom:passwordless'] !== 'Y'}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeAttribute('custom:passwordless', 'N')}
								/>
								<label htmlFor="passwordless_yes">Email link</label>&nbsp;
								<FormInput
									type="radio"
									name="passwordless"
									disabled={isImpersonating}
									defaultChecked={authUser.attributes['custom:passwordless'] === 'Y'}
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeAttribute('custom:passwordless', 'Y')}
								/>
							</FormRow>

							<FormRow>
								<FormLabel htmlFor="email">Correspondence email address</FormLabel>
								<FormLabelHelp>We will use this to contact you regarding bookings</FormLabelHelp>
								<FormInputWithValidation
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('email', e.target.value)}
									type="email"
									required
									name="email"
									id="email"
									defaultValue={customer.email}
									validation={validation} />
							</FormRow>

							<FormRow>
								<FormLabel htmlFor="invoice_email">Invoice email address</FormLabel>
								<FormLabelHelp>We will use this to contact you regarding invoicing</FormLabelHelp>
								<FormInputWithValidation
									onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeFinancial('invoice_email', e.target.value)}
									type="text"
									required
									name="invoice_email"
									id="invoice_email"
									defaultValue={financial.invoice_email}
									validation={validation} />
							</FormRow>
						</Form>
					</AccordionItem>
				</Accordion>
			</div>
		);
	}
}
